import { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import { useStore as useAuthStore } from '../../stores/auth';

export const authHandler = (config: AxiosRequestConfig) => {
  const authStore = useAuthStore();
  config.headers['x-token'] = authStore.tok;
  config.headers['x-customerId'] = authStore.sapCustomerId;
  if (authStore.endCustomerId !== '') {
    config.headers['x-endCustomerId'] = authStore.endCustomerId;
  }
  return config;
};

export const validTokenHandler = (response: AxiosResponse) => {
  const authStore = useAuthStore();
  authStore.setIsTokValid(true);
  return response;
};

export const invalidTokenHandler = (error: AxiosError) => {
  const authStore = useAuthStore();
  if (error.response?.status === 401) {
    authStore.setIsTokValid(false);
  } else {
    authStore.setIsTokValid(true);
  }
  return Promise.reject(error);
};
